import { render, staticRenderFns } from "./TicketProps.vue?vue&type=template&id=204866eb&scoped=true&"
import script from "./TicketProps.vue?vue&type=script&lang=ts&"
export * from "./TicketProps.vue?vue&type=script&lang=ts&"
import style0 from "./TicketProps.vue?vue&type=style&index=0&id=204866eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204866eb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VDatePicker,VDivider,VImg,VSpacer})
